<script>
    export default {
        props: {
            gameID: Number,
        },
        computed: {
            game() {return this.$store.getters.GAMES_BY_ID(this.gameID)},
        },
        emits: ["calldelete"],
    }
</script>

<template>
    <input 
        disabled
        :value="game['name']"
        class="right_input"
    >
    <button
        @click="$emit('calldelete', game['id'])"
        class="button_blue_100 ml_10"
    >Delete</button>
</template>